// @ts-check
import React, { Component, useCallback, useState } from 'react';
import ModalRouter from 'shared/containers/ModalRouter';
import {
  questionAsRulable,
  questionnaireQuestions,
} from 'utils/questionnaireUtils';
import QuestionnaireItemConditionalGroupModal from './QuestionnaireItemConditionalGroupModal';
import Section from './Section';
import Errors from 'shared/components/Errors';
import { Button } from 'preferral-ui/components/Button';
import { ImportExportJSONDrawer } from './ImportExportJSONDrawer';

const modals = [
  {
    name: 'questionnaireItemConditionalGroupModal',
    component: QuestionnaireItemConditionalGroupModal,
  },
];

const newSection = () => ({
  title: '',
  questions: [],
  suppressNotes: false,
  defaultVisible: true,
});

/** @typedef {{
  onChange: function,
  sections: any,
  errorCollection: any,
  referralProfileRulableFields: any
}} QuestionnaireTemplateEditorProps */

/** @typedef {{

}} QuestionnaireTemplateEditorState */

/** @augments { Component<QuestionnaireTemplateEditorProps, QuestionnaireTemplateEditorState> } */
class QuestionnaireTemplateEditor extends Component {
  updateSection = (idx, updatedSection) => {
    const newSections = this.props.sections.map((section, i) => {
      if (i === idx) return updatedSection;
      return section;
    });
    this.props.onChange(newSections);
  };

  removeSection = (idx) => {
    const newSections = this.props.sections.filter((_section, i) => i !== idx);
    this.props.onChange(newSections);
  };

  addSection = () => {
    const newSections = this.props.sections.concat(newSection());
    this.props.onChange(newSections);
  };

  promoteSection = (idx) => {
    if (idx > 0) {
      const sections = this.props.sections;
      const newSections = sections
        .slice(0, idx - 1)
        .concat([sections[idx], sections[idx - 1]])
        .concat(sections.slice(idx + 1));
      this.props.onChange(newSections);
    }
  };

  demoteSection = (idx) => {
    if (this.props.sections[idx + 1]) {
      this.promoteSection(idx + 1);
    }
  };

  combinedRulableFields = () => {
    const questionnaireRulableFields = questionnaireQuestions(
      this.props.sections
    ).map(questionAsRulable);
    return this.props.referralProfileRulableFields.concat(
      questionnaireRulableFields
    );
  };

  render() {
    return (
      <PresentationComponent
        errorCollection={this.props.errorCollection}
        sections={this.props.sections}
        updateSection={this.updateSection}
        removeSection={this.removeSection}
        addSection={this.addSection}
        replaceSections={this.props.onChange}
        promoteSection={this.promoteSection}
        demoteSection={this.demoteSection}
        rulableFields={this.combinedRulableFields()}
      />
    );
  }
}

export default QuestionnaireTemplateEditor;

const PresentationComponent = ({
  errorCollection,
  sections,
  updateSection,
  removeSection,
  addSection,
  replaceSections,
  promoteSection,
  demoteSection,
  rulableFields,
}) => {
  const [activeModal, setActiveModal] = useState(null);
  const closeModal = useCallback(() => setActiveModal(null), []);

  return (
    <>
      <ImportExportJSONDrawer
        isOpen={activeModal === 'IMPORT_EXPORT'}
        onClose={closeModal}
        sections={sections}
        onImport={replaceSections}
      />
      <div>
        <div className="ec-form-section-adder flex items-center justify-between p-3 space-x-2">
          <Button id="top-add-section" size="sm" onClick={addSection}>
            Add Section
          </Button>
          <Button
            size="sm"
            color="teal"
            onClick={() => setActiveModal('IMPORT_EXPORT')}
          >
            Import/Export Sections
          </Button>
        </div>
        <Errors errors={errorCollection ? errorCollection.errors : []} />
        <div className="form-horizontal encounter-note-builder-form">
          {sections.map((section, idx) => (
            <Section
              errorCollection={
                errorCollection ? errorCollection.sections[idx] : null
              }
              key={idx}
              idx={idx}
              section={section}
              demote={() => demoteSection(idx)}
              promote={() => promoteSection(idx)}
              remove={() => removeSection(idx)}
              onChange={(newValue) => updateSection(idx, newValue)}
              rulableFields={rulableFields}
            />
          ))}
        </div>
        <div className="ec-form-section-adder">
          <button className="btn" onClick={addSection}>
            Add Section
          </button>
        </div>

        <ModalRouter modals={modals} />
      </div>
    </>
  );
};
